export default [
  {
    name: 'Basica',
    icon: 'apple-alt',
    tags: [
      {
        id: 'prueba',
        text: 'prueba'
      },
      {
        id: 'texto',
        text: 'texto'
      }
    ],
    elements: [
      {
        row: 1,
        column: 1,
        order: 1,
        elementKey: 'prueba select',
        elementType: 'select',
        labelName: 'Categoría',
        optionList: [
          'Urbano',
          'Paso elevado',
          'Tendido eléctrico',
          'Ferrocarril',
          'Cruce camino',
          'Torre eléctrica',
          'Poste'
        ],
        value: 'Urbano'
      },
      {
        row: 2,
        column: 1,
        order: 1,
        elementKey: 'prueba texto',
        elementType: 'input',
        labelName: 'Nombre',
        dataType: 'text',
        value: 'Nombre de la anotación'
      }
    ]
  },
  {
    name: 'GMV',
    icon: 'info',
    tags: [
      {
        id: 'aaaaaa',
        text: 'aaaaaa'
      }
    ],
    elements: [
      {
        row: 1,
        column: 1,
        order: 1,
        elementKey: 'slo2',
        elementType: 'textarea',
        labelName: 'Description',
        value:
          '### Example Text Area\n\nYou can even use markdown to do some styling:\n\n* Implements [GitHub Flavored Markdown](https://github.github.com/gfm/)\n\nGive it a try.'
      },
      {
        row: 2,
        column: 1,
        order: 1,
        elementKey: 'slo2',
        elementType: 'image',
        caption: 'Switchable bandwidth-monitored website',
        value: 'https://loremflickr.com/640/480/business,meeting,formal/all'
      },
      {
        row: 2,
        column: 2,
        order: 1,
        elementKey: 'slo2',
        elementType: 'image',
        caption: 'Pre-emptive logistical projection',
        value: 'https://loremflickr.com/640/480/business,meeting,formal/all'
      },
      {
        row: 3,
        column: 1,
        order: 1,
        elementKey: 'slo2',
        elementType: 'video',
        caption: 'Ameliorated asynchronous monitoring',
        value: 'https://www.youtube.com/watch?v=yHyMR7T6Kpk&frags=pl%2Cwn'
      }
    ]
  },
  {
    name: 'Traffic Light',
    icon: 'traffic-light',
    tags: [],
    elements: []
  }
];
